import React from 'react';
import { Stepper, GetInfo } from '@operations/shared';
import DeleteLostRequestForm from './deleteExceptionLostRequestForm';
import { getUserByPhoneApi } from '../../utils/apisConsts';
const DeleteExceptionLostRequest = () => {
    const componentSteps = [
        {
        title: 'Get User',
        content: <GetInfo placeHolder="Enter user's Phone number" apiLink={getUserByPhoneApi}/>,
        id: 0,
        }, {
        title: 'Delete Exception Lost Request',
        content: <DeleteLostRequestForm />,
        id: 1
        },
    ];
    
  return (
    <div>
        <Stepper componentSteps={componentSteps} />
    </div>
    
  )
}

export default DeleteExceptionLostRequest